module.exports = {
  lang: {
    t1: `Ana Sayfa`,
    t2: `Kartvizit`,
    t3: `Takip`,
    t4: `İrtibatlar`,
    t5: `Mesajlar`,
    t6: `Giriş`,
    t7: `Kaydol`,
    t8: `Yeni Küresel Ticari Bağlantı Platformu, Kurumsal Dijital Pazarlama Yeni Alanı`,
    t9: `WeMeet - Giriş ile Cep Telefon Numarası`,
    t10: `Cep Telefon Numarası`,
    t11: `Doğrulama Kodu`,
    t12: `Lütfen cep telefonu numarasını girin`,
    t13: `Lütfen doğrulama kodunu girin`,
    t14: `Alma`,
    t15: `Giriş`,
    t16: `Lütfen doğru biçimdeki cep telefonu numarasını girin`,
    t17: `Doğrulama kodu gönderildi`,
    t18: `Girilen doğrulama kodu yanlış. Lütfen kontrol edip tekrar girin.`,
    t19: `Giriş başarılı`,
    t20: `Doğrulama kodunuz (0)’dır. Lütfen {1} dakika içinde kullanın.`,
    t21: `İptal`,
    t22: `Onayla`,
    t23: `İpuçları`,
    t24: `WeMeet hesabınızın kaydı henüz tamamlanmadı. Kayıt işlemi tamamlamak ve çeşitli etkileşimlerin keyfini çıkarmak için şimdi harekete geçin.`,
    t25: `Kayıt sayfasına git`,
    t26: `WeMeet E-posta Giriş`,
    t27: `Hesap Adı`,
    t28: `E-posta adresinizi girin`,
    t29: `Parola`,
    t30: `Parolanızı girin`,
    t31: `Parolamı unuttum mu?`,
    t32: `Giriş yap`,
    t33: `Diğer giriş yolları`,
    t34: `WeMeet Mini Uygulamasına zaten kaydoldunuz mu? Şimdi kullanın.`,
    t35: `Telefon Numarasıyla Giriş Yap`,
    t36: `Lütfen önce e-posta adresinizi girin.`,
    t37: `Lütfen önce şifrenizi girin.`,
    t38: `E-posta adresi biçimi yanlış`,
    t39: `Eğer zaten bir WeMeet hesabınız varsa, doğrudan giriş yapabilirsiniz`,
    t40: `Giriş yap`,
    t41: `Profil fotoğrafı`,
    t42: `Lütfen gerçek bir profil fotoğrafı yükleyin`,
    t43: `Tam adı`,
    t44: `Ad`,
    t45: `Soyadı`,
    t46: `Kuruluş adı`,
    t47: `Lütfen kuruluşunuzun adını giriniz`,
    t48: `Pozisyon`,
    t49: `Lütfen kuruluşunuz içindeki pozisyonunuzu giriniz`,
    t50: `E-posta`,
    t51: `E-posta adresinizi girin`,
    t52: `Cep Telefon Numarası`,
    t53: `Lütfen cep telefonu numarasını girin`,
    t54: `Bölge`,
    t55: `Lütfen bir bölge seçiniz`,
    t56: `Bölge`,
    t57: `Lütfen il, ilçe ve semt seçiniz`,
    t58: `Adres`,
    t59: `Lütfen adresinizi giriniz`,
    t60: `WeMeet Hizmet Şartları ve Gizlilik Politikasını okudum ve kabul ediyorum.`,
    t61: `Hizmet Şartları`,
    t62: `Gizlilik Politikası`,
    t63: `Devam Et`,
    t64: `Lütfen önce Kullanıcı Anlaşmasını işaretleyin`,
    t65: `Lütfen isminizi giriniz`,
    t66: `Soyadınızı giriniz`,
    t67: `Öncelikle e-posta adresinizi girin`,
    t68: `Öncelikle kuruluşunuzun adını girin`,
    t69: `E-posta adresi biçimi yanlış`,
    t70: `İptal`,
    t71: `Tamamlama`,
    t72: `Cep numarasını doğrula`,
    t73: `Cep Telefon Numarası`,
    t74: `Doğrulama Kodu`,
    t75: `Lütfen doğrulama kodunu girin`,
    t76: `Alma`,
    t77: `Doğrulamayı atla`,
    t78: `Gönder`,
    t79: `Doğrulandı`,
    t80: `Girilen doğrulama kodu yanlış. Lütfen kontrol edip tekrar girin.`,
    t81: `Atlandı`,
    t82: `İpuçları`,
    t83: `Girilen telefon numarası zaten bir WeMeet hesabına kaydedilmiş. Tekrar kayıt olmanıza gerek yok, lütfen şimdi giriş yapın.`,
    t84: `Giriş sayfasına git`,
    t85: `İpuçları`,
    t86: `Girilen e-posta adresi zaten bir WeMeet hesabına kaydedilmiş. Tekrar kayıt olmanıza gerek yok, lütfen şimdi giriş yapın.`,
    t87: `Giriş sayfasına git`,
    t88: `Doğrulama bağlantısı gönderildi.`,
    t89: `Lütfen e-postanızı kontrol edin ve kayıt işlemini tamamlamak için bağlantıyı tıklayın.`,
    t90: `Anladım`,
    t91: `WeMeet'a hoş geldiniz`,
    t92: `WeMeet'a hoş geldiniz! Kaydınızı tamamlamak için lütfen düğmeyi tıklayın. Sevgili hatırlatma: Bu bağlantının süresi 24 saat için geçerlidir, lütfen mümkün olan en kısa sürede hareket edin.`,
    t93: `Kayıt Tamamlandı`,
    t94: `E-postanız etkinleştirildi. Lütfen parolanızı girin.`,
    t95: `Parola girin`,
    t96: `Parolanızı girin`,
    t97: `Parolayı onaylayın`,
    t98: `Lütfen parolanızı tekrar girin`,
    t99: `Harfler, rakamlar ve özel karakterlerin kombinasyonunu içermeli ve uzunluğu 8 ile 20 karakter arasında olmalıdır`,
    t100: `Parolanızı girin`,
    t101: `Lütfen parolanızı tekrar girin`,
    t102: `Parolalar eşleşmiyor`,
    t103: `Tebrikler! Kaydınız tamamlandı`,
    t104: `WeMeet'de oturum açıldınız. Önceki işlemlerinizi devam edebilirsiniz.`,
    t105: `Deneyiminizi Devam Et`,
    t106: `İpuçları`,
    t107: `Bağlantı geçersiz kalmıştır. Lütfen tekrar almak için butona tıklayın.`,
    t108: `Tekrar Gönder`,
    t109: `Hizmet Şartları`,
    t110: `Gizlilik Politikası`,
    t111: `Parolayı sıfırla`,
    t112: `Lütfen parolayı sıfırlamak istediğiniz hesabını girin`,
    t113: `Hesap Adı`,
    t114: `E-posta adresinizi girin`,
    t115: `Gönder`,
    t116: `Lütfen önce e-posta adresinizi girin.`,
    t117: `E-posta adresi biçimi yanlış`,
    t118: `E-posta gönderildi`,
    t119: `Lütfen e-postanızı kontrol edin, bağlantıyı tıklayın ve parolanızı sıfırlayın.`,
    t120: `Anladım`,
    t121: `Şifre Sıfırlama - WeMeet`,
    t122: `Şifreniz için sıfırlama talebiniz onaylandı ve sistem sizin için geçici bir şifre sıfırlama bağlantısı oluşturdu. Sevgili hatırlatma: Bu bağlantının süresi 24 saat için geçerlidir, lütfen mümkün olan en kısa sürede hareket edin.`,
    t123: `Şifreyi Sıfırla`,
    t124: `Şifre Sıfırlama Başarılı`,
    t125: `WeMeet'de oturum açıldınız. Tekrar hoşgeldiniz.`,
    t126: `Ana Sayfaya Git`,
    t127: `İrtibatlar`,
    t128: `Yeni İletişim İsteği`,
    t129: `Kabul Et`,
    t130: `.IGNORE`,
    t131: `Onaylandı`,
    t132: `.IGNORED`,
    t133: `Takip`,
    t134: `Takip Edilen`,
    t135: `Mesajlar`,
    t136: `Bekleyen İstek`,
    t137: `Adınızı veya telefon numaranızı girin`,
    t138: `Eşleşen içerik bulunamadı`,
    t139: `Daha fazla yok`,
    t140: `İletişim isteği`,
    t141: `Kabul Et`,
    t142: `.IGNORE`,
    t143: `Onaylandı`,
    t144: `.IGNORED`,
    t145: `WeMeet AI Alanı`,
    t146: `Takip Ediyorum`,
    t147: `Takipten Çıkmış`,
    t148: `vCard`,
    t149: `Bağlan`,
    t150: `Mesaj gönder`,
    t151: `Onay bekliyor`,
    t152: `Kişiyi kaldır`,
    t153: `Kişisel Tanıtım`,
    t154: `Kişisel Profil`,
    t155: `İpuçları`,
    t156: `İletişim isteğiniz gönderildi. Onaylandığında otomatik olarak bu kişiye takip edeceksiniz. Ayrıca, daha fazla bilgi edinmek için şu anda ona takip edebilirsiniz.`,
    t157: `Henüz takip etme`,
    t158: `Takip`,
    t159: `Takip Ediyorum`,
    t160: `Kişisel İletişim Bağlantısını Kaldır`,
    t161: `Kişisel İletişim Bağlantısını Kaldırıldıktan sonra diğer taraf, kişisel bilgilerinizi görüntüleyemez ancak aynı anda takibi iptal etmez.`,
    t162: `Dikkatli Ol`,
    t163: `Kişiyi kaldır`,
    t164: `İşlem Başarılı`,
    t165: `WeMeet AI Yardımcısı`,
    t166: `Lütfen sorunuzu girin`,
    t167: `Gönder`,
    t168: `Lütfen AI etkileşimi içeriğinin doğru olmayabileceğini ve platformun görüşünü yansıtmayabileceğini unutmayın.`,
    t169: `WeMeet İş Kartı`,
    t170: `İndir`,
    t171: `İş Kartını Düzenle`,
    t172: `QR Kodunu İndir`,
    t173: `Resim oluşturuldu. Lütfen kaydedin. Kişiyi kaydetmek için QR kodunu tara.`,
    t174: `Profil fotoğrafı`,
    t175: `Lütfen gerçek bir profil fotoğrafı yükleyin`,
    t176: `Tam adı`,
    t177: `Ad`,
    t178: `Soyadı`,
    t179: `Lütfen isminizi girin`,
    t180: `Kuruluş adı`,
    t181: `Lütfen kuruluşunuzun adını giriniz`,
    t182: `Pozisyon`,
    t183: `Lütfen kuruluşunuz içindeki pozisyonunuzu giriniz`,
    t184: `E-posta`,
    t185: `E-posta adresinizi girin`,
    t186: `Cep Telefon Numarası`,
    t187: `Lütfen cep telefonu numarasını girin`,
    t188: `Bölge`,
    t189: `Lütfen bir bölge seçiniz`,
    t190: `Bölge`,
    t191: `Lütfen il, ilçe ve semt seçiniz`,
    t192: `Adres`,
    t193: `Lütfen adresinizi giriniz`,
    t194: `Lütfen isminizi giriniz`,
    t195: `Soyadınızı giriniz`,
    t196: `Öncelikle e-posta adresinizi girin`,
    t197: `Öncelikle kuruluşunuzun adını girin`,
    t198: `E-posta adresi biçimi yanlış`,
    t199: `Sohbet Odası`,
    t200: `Foto Galerisi`,
    t201: `Foto çek`,
    t202: `Lütfen mesajınızı girin`,
    t203: `Gönder`,
    t204: `Okundu`,
    t205: `Okunmadı`,
    t206: `Geri alma süresi dolmuş`,
    t207: `İptal`,
    t208: `Foto`,
    t209: `Albüm`,
    t210: `Çekim yapmak`,
    t211: `Albümden seçmek`,
    t212: `İptal`,
    t213: `Foto`,
    t214: `Portre`,
    t215: `Ön izleme`,
    t216: `Tamamlama`,
    t217: `WeMeet AI Alan`,
    t218: `Bizimle İletişime Geçin`,
    t219: `Benimle İletişime Geçin`,
    t220: `Tam adı`,
    t221: `Kurum`,
    t222: `Pozisyon`,
    t223: `Telefon`,
    t224: `E-posta`,
    t225: `Bölge`,
    t226: `Bölge`,
    t227: `Adres`,
    t228: `Lütfen isminizi giriniz`,
    t229: `Lütfen kuruluşunuzun adını girin`,
    t230: `Lütfen pozisyonunuzu girin`,
    t231: `Lütfen telefon numaranızı giriniz`,
    t232: `Lütfen e-posta adresinizi girin`,
    t233: `Lütfen bir bölge seçiniz`,
    t234: `Lütfen il, ilçe ve semt seçiniz`,
    t235: `Lütfen bir adres girin`,
    t236: `Amaç`,
    t237: `Ürün satın alma`,
    t238: `Aracılık ürünleri`,
    t239: `Pazar işbirliği`,
    t240: `Diğer`,
    t241: `Lütfen isminizi giriniz`,
    t242: `Lütfen kuruluşunuzun adını girin`,
    t243: `Lütfen e-posta adresinizi girin`,
    t244: `E-posta adresi biçimi yanlış`,
    t245: `Mesaj gönderildi`,
    t246: `Mesaj bırak`,
    t247: `Lütfen sorunuzu yazın`,
    t248: `Onayla`,
    t249: `Lütfen önce giriş yapın veya üye olun`,
    t250: `Takipçi Sayısı`,
    t251: `Bize ulaşın`,
    t252: `Ürünler`,
    t253: `Takım`,
    t254: `Genel bakış`,
    t255: `Albüm`,
    t256: `Yetkinlik`,
    t257: `Kayıtlı sermaye`,
    t258: `Kuruluş Tarihi`,
    t259: `Kayıtlı adres`,
    t260: `Üst akım`,
    t261: `Orta akım`,
    t262: `Alt akım`,
    t263: `Industrie correlate`,
    t264: `Süreç`,
    t265: `Kaydet`,
    t266: `Doğrulandı`,
    t267: `Çince`,
    t268: `İngilizce`,
    t269: `Fransızca`,
    t270: `Rusça`,
    t271: `İspanyolca`,
    t272: `Japonca`,
    t273: `Korece`,
    t274: `Endonezce`,
    t275: `Vietnamca`,
    t276: `Almanca`,
    t277: `Türkçe`,
    t278: `İtalyanca`,
    t279: `Portekizce`,
    t280: `Tayca`,
    t281: `Malayca`,
    t282: `Arapça`,
    t283: `Hesap adı veya şifre yanlış`,
    t284: `Lütfen WeMeet Kullanıcı Sözleşmesini okuyun ve kabul edin`,
    t285: `Geçerli içerik bulunamadı`,
    t286: `Tür`,
    t287: `Özellik`,
    t288: `Ayrıntılar`,
    t289: `Diğer`,
    t290: `Toplam 2 ürün`,
    t291: `{1} sizleri {2}’deki WeMeet AI Space’i ziyaret etmeye davet ediyor`,
    t292: `Bir örnek için burayı tıklayın veya bir soru girin:`,
    t293: `Yenile`,
    t294: `Ayrıca daha fazla bilgi için kişiler eklemek için aşağıdaki kartviziti tıklayabilirsiniz:`,
    t295: `Öğren`,
    t296: `WeMeet Dijital Toplantılar`,
    t297: `WeMeet Dijital Sergiler`,
    t298: `Visitenkarte und WeMeet KI-Raum`,
    t299: `WeMeet kuruluş üyesi nasıl olunur`,
    t300: `WeMeet Dijital Konferans Hizmeti, toplantı oluşturma ve yayınlama, katılımcı kaydı yönetimi, elektronik giriş, toplantı programlama, toplantı materyalinin paylaşımı, gerçek zamanlı etkileşimli tartışmalar ve konuk etkileşimleri de dahil olmak üzere kapsamlı bir çevrimiçi toplantı çözümü sunar.`,
    t301: `WeMeet Dijital Fuar, fuar mikro resmi web sitesini hızlı bir şekilde oluşturmaya yardımcı olur. Katılımcı bilgilerini, sergi tanıtımlarını, canlı fuar yayınlarını, fuar kayıtlarını, etkinlik programlarını ve daha fazlasını göstererek katılan şirketlerin ve izleyicilerin fuar detaylarını kolayca anlamalarını sağlar. WeMeet Dijital Fuar özelliğini kullanmak için lütfen önce kurumsal giriş sürecini tamamlayın. "Benim"e tıklayın, "Hizmet Merkezi" - "Kurumsal Giriş"e kadar kaydırın ve giriş sürecini tamamlamak için talimatları izleyin.`,
    t302: `WeMeet kişisel kullanıcıları, kişisel dijital bir kartvizit almak ve kişisel AI Lounge'larını (kişisel özgeçmiş, güncellemeler, fotoğraflar, belgeler vb. içeren) sürdürmek için yalnızca WeChat kimliklerini, telefon numaralarını yetkilendirmeleri ve platform kayıtlarını tamamlamaları yeterlidir.`,
    t303: `Mini programın alt menü çubuğunda "Benim" seçeneğine tıklayarak kişisel iş kartı sayfasını güncelleyin ve kişisel ana sayfayı iyileştirin.`,
    t304: `Büyük ve küçük harflerin, rakamların ve noktalama işaretlerinin birleşimi, 8-20 karakter arasında uzunlukta.`,
    t305: `Ürün adını girin`,
    t306: `Daha fazla yok`,
    t307: `Sağ üst köşeye tıklayın`,
    t308: `Tercih ettiğiniz paylaşım yolunu seçin`,
    t309: `Anladım`,
    t310: `Lütfen önce kaydı tamamlayın ve giriş yapın`,
    t311: `Daha fazla bilgi edinin`,
    t312: `İlgili Ürünler`,
    t313: `Ziyaretiniz için teşekkür ederiz`,
    t314: `Çıkış Yap`,
    t315: `Takip edilen kuruluşlar`,
    t316: `Önceki`,
    t317: `Sonraki`,
    t318: `Hiçbiri`,
    t319: `{1} sizi {2} ziyaret etmeye davet ediyor`,
    t320: `AI Lounge güncel dilini korumamıştır`,
    t321: `AI Lounge şu anda ki diline geçti`,
    t322: `Bağlantı etkinleştirildi`,
    t323: `Ağ meşgul, lütfen daha sonra tekrar deneyin`,
    t324: `Ürün detayları mevcut dile geçirildi`,
    t325: `Ürün detayları şu anda bu dilde korunmamaktadır`,
    t326: `Merhaba, ben WeMeet akıllı AI asistanıyım, size her zaman düşünceli bir hizmet sunmaya hazırım! Size nasıl yardımcı olabilirim?`,
    t327: `İsim giriniz`,
    t328: `İlgili iletişim bilgilerini buldum, lütfen aşağıdaki iletişim kartını kontrol edin.`,
    t329: `Ek`,
    t330: `İlgili iletişim bilgilerini bulamadım.`,
    t331: `Sorumluluk sahibi meslektaşa sorgunuzu ilettim; ayrıca kartvizite tıklayarak hemen iletişime geçebilirsiniz.`,
    t332: `Sergi`,
    t333: `Lütfen girin`,
    t334: `Kullanıcı`,
    t335: `Daha fazla yok`,
    t336: `Yenileme başarılı`,
    t337: `Yükleniyor`,
    t338: `Yenilemek için serbest bırak`,
  },
};

// 土耳其
